var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashExpiredInventoryValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6749 5.59778C12.9175 4.23458 11.0663 4.23458 10.3089 5.59778L3.66119 17.6546C2.8758 19.0481 3.82949 20.8354 5.34416 20.8354H18.6677C20.1823 20.8354 21.108 19.0481 20.3506 17.6546L13.6749 5.59778ZM11.9077 8.32419C12.5248 8.2636 13.0578 8.7483 13.0858 9.41475C13.0858 9.47534 13.0858 9.56622 13.0858 9.62681L12.7212 14.1405C12.6931 14.5646 12.3285 14.8979 11.9358 14.8676C11.5711 14.8373 11.2906 14.5343 11.2626 14.1405L10.898 9.62681C10.8419 8.96035 11.2906 8.38478 11.9077 8.32419ZM11.9919 18.3816C11.3467 18.3816 10.8138 17.806 10.8138 17.1093C10.8138 16.4125 11.3467 15.837 11.9919 15.837C12.637 15.837 13.17 16.4125 13.17 17.1093C13.17 17.806 12.637 18.3816 11.9919 18.3816Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8843 9.45414C10.8431 8.81426 11.351 8.27261 11.9922 8.27261C12.6389 8.27261 13.1487 8.82314 13.0991 9.46792L12.7385 14.1569C12.7073 14.5622 12.3693 14.8752 11.9629 14.8752C11.5527 14.8752 11.213 14.5566 11.1866 14.1473L10.8843 9.45414Z",
    fill: "transperent"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9991,
    cy: 17.1208,
    r: 1.31201,
    fill: "transperent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashExpiredInventoryValue);
export default __webpack_public_path__ + "static/media/dash-expired-inventory-value.72a22b5126f92b35b524ed590ab2b96e.svg";
export { ForwardRef as ReactComponent };